<app-search-investisseur-autocomplete
  [label]="label"
  [initInvestisseur]="initInvestisseur"
  [isInvestisseurSet]="isInvestisseurSet"
  [isRequired]="isRequired"
  [isContactStatutExcluded]="isContactStatutExcluded"
  [isClientStatutOnly]="isClientStatutOnly"
  [fullDisplay]="fullDisplay"
  [defaultQueryFilter]="defaultQueryFilter"
  [investisseurControl]="investisseurControl"
  [typePersonnes]="[InvestisseurType.PersonnePhysique]"
  (onInvestisseurIdSelected)="onInvestisseurIdSelected.emit($event)"
  (onInvestisseurPersonneSelected)="onInvestisseurPersonneSelected.emit($event)"></app-search-investisseur-autocomplete>
